import { render, staticRenderFns } from "./TransferModal.vue?vue&type=template&id=63a16dae&scoped=true&"
import script from "./TransferModal.vue?vue&type=script&lang=js&"
export * from "./TransferModal.vue?vue&type=script&lang=js&"
import style0 from "./TransferModal.vue?vue&type=style&index=0&id=63a16dae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a16dae",
  null
  
)

export default component.exports